export const BEFORE_FETCH_ADVERT_DETAILS = 'BEFORE_FETCH_ADVERT_DETAILS';
export const FETCH_ADVERT_DETAILS = 'FETCH_ADVERT_DETAILS';
export const NETWORK_ERROR_FETCHING_ADVERT_DETAILS = 'NETWORK_ERROR_FETCHING_ADVERT_DETAILS';

export const BEFORE_FETCH_ADVERT_VIEWS_BAR_CHART_DATA = 'BEFORE_FETCH_ADVERT_VIEWS_BAR_CHART_DATA';
export const FETCH_ADVERT_VIEWS_BAR_CHART_DATA = 'FETCH_ADVERT_VIEWS_BAR_CHART_DATA';
export const NETWORK_ERROR_FETCHING_ADVERT_VIEWS_BAR_CHART_DATA = 'NETWORK_ERROR_FETCHING_ADVERT_VIEWS_BAR_CHART_DATA';